<template>
  <div>
    <b-card class="shaddow-hover">
      <b-row>
        <b-col class="text-left">
          <b>{{ $utils.capitalize(partnerLevel.name) }}</b>
        </b-col>
        <b-col md="4" class="justify-content-end d-flex w-100 buttons-action-partner-level-card">
          <div class="btn-group">
            <button
              class="btn btn-sm btn-primary"
              v-b-tooltip.hover
              :title="$t('Partners')"
              @click="editPartnerLevel(partnerLevel)"
            >
              <i class="fa fa-edit" />
            </button>
            <button
              v-if="partnerLevel.level != 1"
              class="btn btn-sm btn-primary"
              v-b-tooltip.hover
              :title="$t('Detail')"
              @click="onFilter"
            >
              <i class="fa fa-list" />
            </button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <partnerLevelDetails :partnerLevel="partnerLevel" :showLevels="showLevels" />
      </b-row>
      <b-row
        v-if="partnerLevel.partners.length && !partnerLevel.partners.includes(null) && !showLevels"
        class="pt-2 pb-3"
      >
        <button class="btn btn-transparent mt-2" @click="expandLevels">
          <small>{{ $t('Show Details') }}</small>
        </button>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import partnerLevelDetails from './partnerLevelDetails';
export default {
  emits: ['onFilter'],
  props: ['partnerLevel'],
  components: { partnerLevelDetails },
  data() {
    return {
      showLevels: false
    };
  },
  methods: {
    onFilter() {
      if (!this.partnerLevel?.id || !this.partnerLevel?.lowers?.length) {
        this.$customAlert({
          msg: this.$t('This partner level has no lower levels registered'),
          type: 'warning'
        });
        return;
      }
      this.$emit('onFilter', this.partnerLevel.id);
    },
    editPartnerLevel(pl) {
      this.$router.push({
        name: 'partnerLevelUpdate',
        params: {
          id: pl.id
        }
      });
    },
    expandLevels() {
      this.showLevels = true;
    }
  }
};
</script>

<style>
.buttons-action-partner-level-card {
  position: absolute;
  top: 10px;
  right: 0px;
}
</style>
